import { Injectable } from '@angular/core';
import { Avis } from 'src/app/models/avis';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { FormExtractorService } from 'src/app/modules/shared/services/form-extractor.service';
import { StatutAvisEnum } from '../../../../models/enums/statut-avis.enum';
import { LogService } from '../../../shared/services/log.service';
import { Annonce } from '../../common/models/annonce';
import { TypeAnn } from '../../common/models/type.ann';
import { Annulation } from './models/Annulation';
import { AnnulationService } from './services/annulation/annulation.service';
import { FNSimple } from '../common/models/FNSimple';
import { FnsimpleService } from '../common/services/fnsimple.service';
import { CommonService } from '../../common/services/common/common.service';
import { TypeAvisEnum } from '../../../../models/enums/type-avis.enum';
import { AvisDataTransferService } from '../../../shared/services/avis-data-transfer.service';

@Injectable({
	providedIn: 'root',
})
export class FormFnSimpleAnnulationExtractorService {
	private LOG: LogService = new LogService(FormFnSimpleAnnulationExtractorService);

	constructor(private formExtractorService: FormExtractorService, private annulationService: AnnulationService,
				private commonService: CommonService, private fnsimpleService: FnsimpleService,
				private avisDataTransferService: AvisDataTransferService) {}

	public mapFormToAvis(form, stepId, actualFormIdAnnEmetteur): Avis {
		const controls = this.formExtractorService.getMapControlsIdWithoutStepAndValue(form);

		const annulation = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.fnSimple.annulationFromFNSimple;

		if (stepId === 5) {
			annulation.infosAnnulation = controls.get('_SepSep_Annulation_SepAtt_infosAnnulation');
		}
		if (stepId === 1) {
			annulation.avisInitial = this.annulationService.avisInitialService.getAvisInitial(controls);
		}
		if (stepId === 3 || stepId === 4) {
			annulation.natureMarche = this.annulationService.natureMarcheService.getNatureMarche(controls, stepId);
		}
		const fnSimple: FNSimple = this.avisDataTransferService.getFormData().jsonSaisieFormulaire.ann.fnSimple;
		if (stepId === 2) {
			fnSimple.organisme = this.fnsimpleService.organismeService.getOrganisme(controls);
		}
		fnSimple.initialFromFNSimple = null;
		fnSimple.attribution = null;
		fnSimple.rectificatifFromFNSimple = null;
		fnSimple.annulationFromFNSimple = annulation;

		const annonce: Annonce = new Annonce();
		annonce.ann.idAnnEmetteur = actualFormIdAnnEmetteur;
		annonce.ann.divers = null;
		annonce.ann.mapa = null;
		annonce.ann.fnSimple = fnSimple;
		annonce.ann.formAD = null;
		annonce.ann.facturation = this.commonService.facturationService.getFacturation(form, 'DIV', controls);
		annonce.ann.indexation = this.commonService.indexationService.getIndexation(form);
		annonce.ann.dateEnvoi = controls.get('_SepSep_Annonce_index_1_SepSep_TypeAnn_SepAtt_dateEnvoi');

		annonce.annonceur.login = controls.get('_SepSep_idAnnonceur_SepAtt_idannonceurboampweb');
		annonce.annonceur.mail = controls.get('_SepSep_idAnnonceur_SepAtt_mailcontactboampweb');
		//Nettoyer les blocs inexistants
		const avis: Avis = new Avis();
		avis.jsonSaisieFormulaire = annonce;
		avis.formulaire.code = FormsEnum[FormsEnum.SIMP_AN];
		avis.statut = StatutAvisEnum.ELABORE;
		avis.critere.typeAvis.code=TypeAvisEnum.C4_5;
		return avis;
	}
}
